import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { CAMPAIGN_VARIANT_TOP_SPACING } from '../campaignSpacing';
import { LocationFeaturesWidgetComponent } from './LocationFeaturesWidgetComponent';

/**
 * Campaign variant B. Was a bare re-export of
 * {@link LocationFeaturesWidgetComponent} until SH-415 — it had to become a
 * real wrapper to carry the variant's top margin, since a class added to the
 * shared component would have landed on variant A as well.
 */
export function LocationFeaturesWidgetComponentB(
  props: React.ComponentProps<typeof LocationFeaturesWidgetComponent>,
) {
  return (
    <LocationFeaturesWidgetComponent
      {...props}
      className={classNames(props.className, CAMPAIGN_VARIANT_TOP_SPACING)}
    />
  );
}
